import {createSlice} from '@reduxjs/toolkit';
import {JwtToken} from './types';

type SliceState = {
  token: JwtToken | null;
  email: string;
  firstName: string;
  lastName: string;
  isAdmin: boolean;
  debugEmail: string;
  debugPremiumOverride: boolean | null;
  debugLanguageOverride: string | null;
  debugApiUrl: string | null;
};

const initialState: SliceState = {
  token: null,
  email: '',
  firstName: '',
  lastName: '',
  isAdmin: false,
  debugEmail: '',
  debugPremiumOverride: null,
  debugLanguageOverride: null,
  debugApiUrl: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    storeToken: (state, {payload: token}: {payload: JwtToken}) => {
      state.token = token;
    },
    storeUserData: (
      state,
      {
        payload: {
          token,
          userInfo: {email, firstName, lastName, isAdmin},
        },
      }: {
        payload: {
          token?: JwtToken;
          userInfo: {
            email: string;
            firstName: string;
            lastName: string;
            isAdmin: boolean;
          };
        };
      },
    ) => {
      if (token) {
        state.token = token;
      }
      state.email = email;
      state.firstName = firstName;
      state.lastName = lastName;
      state.isAdmin = isAdmin;
    },
    setDebugEmail: (state, {payload: email}: {payload: string}) => {
      state.debugEmail = email;
      if (!email) {
        state.debugPremiumOverride = null;
        state.debugLanguageOverride = null;
      }
    },
    setDebugPremiumOverride: (state, {payload}: {payload: boolean | null}) => {
      state.debugPremiumOverride = payload;
    },
    setDebugLanguageOverride: (state, {payload}: {payload: string | null}) => {
      state.debugLanguageOverride = payload;
    },
    setDebugApiUrl: (state, {payload}: {payload: string | null}) => {
      state.debugApiUrl = payload;
    },
  },
});

export const {
  storeToken,
  storeUserData,
  setDebugEmail,
  setDebugPremiumOverride,
  setDebugLanguageOverride,
  setDebugApiUrl,
} = userSlice.actions;

export default userSlice.reducer;
